import { tablePageSizeOptions } from '@ui-kit/table/_core';
import { cloneDeep } from 'lodash-es';
import { feeWaiversTableConfig } from '../misc';
import { FeeWaiversOperations } from '../types';

const systemDefaultOperations: FeeWaiversOperations = {
    searchValue: '',
    pagination: {
        skip: 0,
        take: tablePageSizeOptions[1] || 15,
    },
    columns: feeWaiversTableConfig().columns,
    skipDataReload: false,
};

function getSystemDefaultOperations(): FeeWaiversOperations {
    return cloneDeep(systemDefaultOperations);
}

export const FeeWaiversHelper = {
    getSystemDefaultOperations,
};
